import { margins } from '@olist/styled-system';
import styled, { css } from 'styled-components';
import { focusContainer } from '../../utils/focusContainer.js';
import '../../utils/opacityDisabled.js';
import '../Text/Caption/Caption.js';
import '../Text/DetailedSubheading/DetailedSubheading.js';
import '../Text/OverlineLg/OverlineLg.js';
import '../Text/OverlineMd/OverlineMd.js';
import ParagraphLg from '../Text/ParagraphLg/ParagraphLg.js';
import '../Text/ParagraphMd/ParagraphMd.js';
import '../Text/SectionHeading/SectionHeading.js';
import '../Text/SectionSubheading/SectionSubheading.js';
import '../Text/Title/Title.js';

const Wrapper = styled.div(({ theme: { olist: { components: { toggle }, }, }, label, disabled, readOnly, hideBorder, }) => css `
    height: auto;
    min-height: 44px;
    position: relative;
    padding-inline: ${toggle.spacing.inline};

    display: flex;
    align-items: center;

    ${label &&
    css `
      width: 100%;
      justify-content: space-between;
      border-bottom: ${hideBorder
        ? 'none'
        : `1px solid ${toggle.label['border-color']}`};
    `}

    ${ParagraphLg} {
      margin-right: ${toggle.label.margin};
      white-space: break-spaces;
      flex-grow: 1;
    }

    ${disabled
    ? css `
          ${ParagraphLg} {
            color: ${toggle.states.disabled.color};
          }
          ${Input}:disabled + ${ToggleControl} {
            background-color: ${toggle.states.disabled.background};
          }
          ${Input} {
            cursor: not-allowed;
          }
          ${ToggleControl}::before {
            background-color: ${toggle.states.disabled.thumb.background};
            box-shadow: initial;
          }
        `
    : css `
          &:hover {
            ${readOnly
        ? css `
                  ${Input} {
                    cursor: initial;
                  }
                `
        : css `
                  background-color: ${toggle.hover.background};
                  ${!label &&
            css `
                    border-radius: ${toggle.radius};
                  `}
                `}
          }
          ${focusContainer({ within: true }) `
              border-color: transparent;
              border-radius: ${toggle.radius};
              background-color: ${toggle.focus.background};
          `}
        `}

    ${margins}
  `);
const WrapperToggle = styled.div ``;
const Input = styled.input(({ theme: { olist: { components: { toggle }, }, }, variation = 'success', }) => css `
    opacity: 0;
    position: absolute;
    height: 24px;
    width: 40px;
    margin: 0;

    z-index: 1;
    cursor: pointer;

    &:checked + ${ToggleControl} {
      background-color: ${toggle.styles[variation].checked.background};
    }

    &:checked + ${ToggleControl}::before {
      transform: translate(100%, -50%);
    }
  `);
const ToggleControl = styled.span(({ theme: { olist: { components: { toggle }, }, }, }) => css `
    display: block;
    position: relative;
    width: 40px;
    height: 24px;
    border-radius: ${toggle.label.radius};
    padding: ${toggle.label.padding};
    background-color: ${toggle.states.rest.background};
    box-sizing: border-box;

    &::before {
      content: '';
      position: absolute;
      width: 16px;
      height: 16px;

      background-color: ${toggle.states.rest.thumb.background};
      border-radius: ${toggle.states.rest.thumb.radius};
      box-shadow: ${toggle.states.rest.thumb.shadow};

      top: 50%;
      transform: translate(0, -50%);

      transition: transform 200ms linear;
    }
  `);

export { Input, ToggleControl, Wrapper, WrapperToggle };
